import { createSlice } from "@reduxjs/toolkit";
import { token } from '../../models/auth/auth.models';
import { clearLocalStorage, persistLocalStorage } from "../../util/localStorage.utility";

const estadoInicial: token = {
    token: '',
};

export const TokenID = 'token';

const openSlice = createSlice({
    name: 'token',
    initialState: estadoInicial,
    reducers: {
        guardarToken: (_state, action) => {
            persistLocalStorage<token>('token', action.payload);
            return action.payload;
        },
        limpiarToken: () => {
            clearLocalStorage(TokenID);
            return estadoInicial;
        }
    }
});

export const { guardarToken, limpiarToken } = openSlice.actions;

export default openSlice.reducer;
